import {
    request
} from './request'

// 获取banner列表
function getBanner(data) {
    return request({
        method: 'get',
        url: '/api/v1/index/banner',
        params: data
    })
}

// 合作伙伴
function partner() {
    return request({
        method: 'get',
        url: '/api/v1/index/partner'
    })
}

export {
    getBanner,
    partner
}


// WEBPACK FOOTER //
// ./src/api/home.js